import axios from 'axios'
import { getField, updateField } from 'vuex-map-fields'

export default {
  state: {
    // 分類名稱 給左上角Break crumb用
    categoryName: '',
    categoryId: null,
    // 篩選下方照片用
    productId: null,
    // 規格名稱
    standardTitle: '',
    originTitle: '',
    // 右上方小圖
    productSpec: [],
    // 全部資料
    productItem: [],
    // 下方文字資料
    productFeature: [],
    //
    productMaster: [],
    // 網友推薦
    productRecommend: [],
    // 規格頁數選資料
    productIntroDesc: [],
    productIntroLeftCol: [],
    productIntroRightCol: [],
    // 方向
    direction: '',
    // 對應方向
    specId: null,
    // 對應尺寸
    sizeId: null,
    styleId: null,
    // Taopix 連結
    editLink: '',
    price: null,
    priceRange: null,
    discountprice: null,
    discountpriceForecolor: null,
    discountpriceBgcolor: null,
    // 提示文字和顏色
    note: null,
    noteForecolor: null,
    noteBgcolor: null,
    enableEdit: null,
    editorPrePage: null,
    // pdf上傳轉img
    pdfInuptCount: 0,
    pdfInputSize: 0,
    pdfInputFile: [],
    pdfResponseFileName: ''
  },
  actions: {
    getStandardData (context, {id}) {
      let API_PATH = process.env.API
      context.commit('LOADING', true, {root: true})
      let getAPI = `${API_PATH}product/getdetail/${id}`
      return axios.get(getAPI).then((response) => {
        let {productSpec, productItem, productFeature, productRecommend, productMaster, productIntroDesc} = response.data.data
        // 規格標題
        let originTitle = productItem[0].productName
        if (originTitle.includes('簡約直式桌曆')) {
          originTitle = originTitle.concat('(底板可印字)')
        } else if (originTitle.includes('精品實木座桌曆')) {
          originTitle = originTitle.concat('(可刻字)')
        }
        let standardTitle = productItem[0].productName
        let categoryName = productItem[0].categoryName
        let categoryId = productItem[0].categoryId
        let productId = productItem[0].productId
        context.commit('changeStandardData', {productSpec, productItem, productFeature, originTitle, standardTitle, categoryName, categoryId, productId, productRecommend, productMaster, productIntroDesc})
        context.commit('LOADING', false, {root: true})
      }).catch((error) => { console.log(error) })
    },
    // 開啟modal
    showModal () {
      $('#noticeModal').modal('show')
      $('#tpx-basket-bar').css('z-index', '0')
    },
    // 關閉modal
    closeModal (url) {
      $('#noticeModal').modal('hide')
      // taopix 預設css
      setTimeout(function () {
        $('#tpx-basket-bar').css('z-index', '900')
      }, 1000)
    },
    // pdf上傳轉jpg
    pdfFileUpload ({state, commit}) {
      let API_PATH = process.env.API
      let basketref = window.tpxReadCookie('mawebhlbr')
      let getAPI = `${API_PATH}pdftoimg/fileupload`
      let errMsg = ''
      commit('LOADING', true, {root: true})

      const formData = new FormData()
      formData.append('basketref', basketref)
      state.pdfInputFile.forEach(file => {
        formData.append('files[]', file)
      })

      return axios.post(getAPI, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        // console.log('success')
        // console.log(response)
        // console.log(response.data.error_message)
        if (response.data.error_message !== '') {
          errMsg = response.data.error_message
        }
        state.pdfResponseFileName = response.data.data[0].filename
        state.pdfInuptCount = 0
        state.pdfInputSize = 0
        state.pdfInputFile = []
        commit('LOADING', false, {root: true})
      }).catch((error) => {
        // console.log('error')
        commit('LOADING', false, {root: true})
        // console.log(error)
        // console.log(error.response)
        if (error.response && error.response.data && error.response.data.message) {
          alert(error.response.data.message)
        } else if (error.response && error.response.error_message) {
          alert(error.response.error_message)
        } else {
          alert(errMsg)
        }
      })
    },
    // pdf上傳轉jpg 下載
    pdfImgFileDownload ({state, commit}) {
      let API_PATH = process.env.API
      let basketref = window.tpxReadCookie('mawebhlbr')
      let getAPI = `${API_PATH}pdftoimg/download`
      let file = state.pdfResponseFileName

      const requestData = {
        basketref: basketref,
        file: file
      }

      commit('LOADING', true, {root: true})
      axios.post(getAPI, requestData).then(response => {
        // 資料源是base64
        const link = document.createElement('a')
        link.href = response.data
        link.download = file
        link.click()
        commit('LOADING', false, {root: true})
      }).catch(error => {
        commit('LOADING', false, {root: true})
        alert('發生錯誤，請稍後再試')
        console.error('Download failed!', error.response)
      })
    }
  },
  mutations: {
    changeStandardData (state, {productSpec, productItem, productFeature, originTitle, standardTitle, categoryName, categoryId, productId, productRecommend, productMaster, productIntroDesc}) {
      state.productSpec = productSpec
      state.productItem = productItem
      state.productFeature = productFeature
      state.direction = productSpec[0].specName
      state.specId = productSpec[0].specId
      state.sizeId = productSpec[0].productSize[0].sizeId
      state.styleId = productItem[0].styleId
      state.originTitle = originTitle
      state.standardTitle = standardTitle
      state.categoryName = categoryName
      state.categoryId = categoryId
      state.productId = productId
      state.productRecommend = productRecommend
      state.productMaster = productMaster
      state.productIntroDesc = productIntroDesc
      state.discountpriceForecolor = productItem[0].discountpriceForecolor
      state.discountpriceBgcolor = productItem[0].discountpriceBgcolor
      state.note = productItem[0].note
      state.noteForecolor = productItem[0].note_forecolor
      state.noteBgcolor = productItem[0].note_bgcolor
      state.editorPrePage = productMaster[0].editorPrePage
    },
    updateField
  },
  // computed
  getters: {
    getField,
    // 改變規格改變尺寸
    productSize (state) {
      let productSize = []
      state.productSpec.forEach(item => {
        if (item.specId === state.specId) {
          productSize = item.productSize
          state.sizeId = item.productSize[0].sizeId
        }
      })
      return productSize
    },
    // 選specid sizeid秀詳細資料
    specId_sizeId_info (state, getters) {
      let productIntroLeftCol = []
      let productIntroRightCol = []
      let productIntroId = []
      let link = null
      let price = null
      let priceRange = null
      let cnt = null
      let parameters = []
      // 取得判斷是否要進到風格的cnt
      state.productSpec.forEach(itm => {
        itm.productSize.forEach(item => {
          if (item.sizeId === state.sizeId) {
            cnt = item.cnt
          }
        })
      })
      // 用specid and sizeid 篩選價錢跟編輯連結
      state.productItem.forEach((itm) => {
        if (itm.specId === state.specId && itm.sizeId === state.sizeId) {
          state.editLink = itm.editLink
          link = itm.editLink
          state.price = itm.price
          state.discountprice = itm.discountprice
          parameters = JSON.parse(itm.parameters)

          // 判斷價格是否有起
          if (itm.price !== null && itm.price[itm.price.length - 1] === '起') {
            price = itm.price.substring(0, itm.price.length - 1)
            state.priceRange = true
            priceRange = true
          } else {
            price = itm.price
            state.priceRange = true
            priceRange = false
          }
        }
      })
      // 組合產品特性
      state.productIntroDesc.forEach((item, idx) => {
        productIntroLeftCol.push(item.introName)
        productIntroId.push(item.productIntroId)
        if (idx === 0) {
          getters.productSize.forEach(itm => {
            if (itm.sizeId === state.sizeId) productIntroRightCol.push(itm.sizeDesc)
          })
        } else {
          productIntroRightCol.push(item.productIntroDesc)
        }
      })
      state.productIntroLeftCol = productIntroLeftCol
      state.productIntroRightCol = productIntroRightCol
      return {parameters, productIntroLeftCol, productIntroRightCol, productIntroId, link, price, priceRange, cnt}
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/standard.js